import { c as _c } from "react/compiler-runtime";
import { useMemo, type ComponentType } from "react";
import { UsersIcon, WrenchIcon, DocumentTextIcon } from "@heroicons/react/24/outline";
import Squares2X2Icon from "@/components/common/icons/Squares2X2Icon";
import { SidebarSection } from "@/components/navigation/navTypes";
import { AboutSection } from "@/enums";
export function useSidebarSections(appWalletsSupported, isIos, country) {
  const $ = _c(43);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      name: "Identities",
      href: "/network"
    }, {
      name: "Activity",
      href: "/network/activity"
    }, {
      name: "Groups",
      href: "/network/groups"
    }, {
      name: "NFT Activity",
      href: "/nft-activity"
    }, {
      name: "Memes Calendar",
      href: "/meme-calendar"
    }, {
      name: "TDH",
      href: "/network/tdh"
    }, {
      name: "xTDH",
      href: "/network/xtdh"
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      key: "network",
      name: "Network",
      icon: UsersIcon,
      items: t0,
      subsections: [{
        name: "Metrics",
        items: [{
          name: "Definitions",
          href: "/network/definitions"
        }, {
          name: "Network Stats",
          href: "/network/stats"
        }, {
          name: "Levels",
          href: "/network/levels"
        }]
      }]
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      key: "collections",
      name: "Collections",
      icon: Squares2X2Icon,
      items: [{
        name: "The Memes",
        href: "/the-memes"
      }, {
        name: "6529 Gradient",
        href: "/6529-gradient"
      }, {
        name: "NextGen",
        href: "/nextgen"
      }, {
        name: "Meme Lab",
        href: "/meme-lab"
      }, {
        name: "ReMemes",
        href: "/rememes"
      }, {
        name: "xTDH",
        href: "/xtdh"
      }],
      subsections: []
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      name: "NFT Delegation",
      items: [{
        name: "Delegation Center",
        href: "/delegation/delegation-center"
      }, {
        name: "Wallet Architecture",
        href: "/delegation/wallet-architecture"
      }, {
        name: "Delegation FAQs",
        href: "/delegation/delegation-faq"
      }, {
        name: "Consolidation Use Cases",
        href: "/delegation/consolidation-use-cases"
      }, {
        name: "Wallet Checker",
        href: "/delegation/wallet-checker"
      }]
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== country || $[6] !== isIos) {
    t5 = !isIos || country?.toUpperCase() === "US" ? [{
      name: "Memes Subscriptions",
      href: "/tools/subscriptions-report"
    }] : [];
    $[5] = country;
    $[6] = isIos;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      name: "Memes Accounting",
      href: "/meme-accounting"
    };
    t7 = {
      name: "Memes Gas",
      href: "/meme-gas"
    };
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5) {
    t8 = {
      name: "The Memes Tools",
      items: [...t5, t6, t7]
    };
    $[10] = t5;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== appWalletsSupported) {
    t9 = appWalletsSupported ? [{
      name: "App Wallets",
      href: "/tools/app-wallets"
    }] : [];
    $[12] = appWalletsSupported;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      name: "API",
      href: "/tools/api"
    };
    t11 = {
      name: "EMMA",
      href: "/emma"
    };
    t12 = {
      name: "Block Finder",
      href: "/tools/block-finder"
    };
    t13 = {
      name: "Open Data",
      href: "/open-data"
    };
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
  } else {
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t9) {
    t14 = {
      name: "Other Tools",
      items: [...t9, t10, t11, t12, t13]
    };
    $[18] = t9;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t14 || $[21] !== t8) {
    t15 = {
      key: "tools",
      name: "Tools",
      icon: WrenchIcon,
      items: t3,
      subsections: [t4, t8, t14]
    };
    $[20] = t14;
    $[21] = t8;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [{
      name: "GDRC1",
      href: `/about/${AboutSection.GDRC1}`
    }];
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      name: "The Memes",
      href: `/about/${AboutSection.MEMES}`
    };
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== country || $[26] !== isIos) {
    t18 = !isIos || country?.toUpperCase() === "US" ? [{
      name: "Subscriptions",
      href: `/about/${AboutSection.SUBSCRIPTIONS}`
    }] : [];
    $[25] = country;
    $[26] = isIos;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  let t20;
  let t21;
  let t22;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      name: "Minting",
      href: `/about/${AboutSection.MINTING}`
    };
    t20 = {
      name: "Nakamoto Threshold",
      href: `/about/${AboutSection.NAKAMOTO_THRESHOLD}`
    };
    t21 = {
      name: "Meme Lab",
      href: `/about/${AboutSection.MEME_LAB}`
    };
    t22 = {
      name: "Gradients",
      href: `/about/${AboutSection.GRADIENTS}`
    };
    $[28] = t19;
    $[29] = t20;
    $[30] = t21;
    $[31] = t22;
  } else {
    t19 = $[28];
    t20 = $[29];
    t21 = $[30];
    t22 = $[31];
  }
  let t23;
  if ($[32] !== t18) {
    t23 = {
      name: "NFTs",
      items: [t17, ...t18, t19, t20, t21, t22]
    };
    $[32] = t18;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      name: "NFT Delegation",
      items: [{
        name: "About NFTD",
        href: `/about/${AboutSection.NFT_DELEGATION}`
      }, {
        name: "Primary Address",
        href: `/about/${AboutSection.PRIMARY_ADDRESS}`
      }]
    };
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  let t25;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      name: "6529 Capital",
      items: [{
        name: "About 6529 Capital",
        href: "/capital"
      }, {
        name: "Company Portfolio",
        href: "/capital/company-portfolio"
      }, {
        name: "NFT Fund",
        href: "/capital/fund"
      }]
    };
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  let t26;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      name: "Support",
      items: [{
        name: "FAQ",
        href: `/about/${AboutSection.FAQ}`
      }, {
        name: "Apply",
        href: `/about/${AboutSection.APPLY}`
      }, {
        name: "Contact Us",
        href: `/about/${AboutSection.CONTACT_US}`
      }]
    };
    $[36] = t26;
  } else {
    t26 = $[36];
  }
  let t27;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      name: "Resources",
      items: [{
        name: "Data Decentralization",
        href: `/about/${AboutSection.DATA_DECENTR}`
      }, {
        name: "ENS",
        href: `/about/${AboutSection.ENS}`
      }, {
        name: "License",
        href: `/about/${AboutSection.LICENSE}`
      }, {
        name: "Release Notes",
        href: `/about/${AboutSection.RELEASE_NOTES}`
      }]
    };
    $[37] = t27;
  } else {
    t27 = $[37];
  }
  let t28;
  if ($[38] !== t23) {
    t28 = {
      key: "about",
      name: "About",
      icon: DocumentTextIcon,
      items: t16,
      subsections: [t23, t24, t25, t26, t27]
    };
    $[38] = t23;
    $[39] = t28;
  } else {
    t28 = $[39];
  }
  let t29;
  if ($[40] !== t15 || $[41] !== t28) {
    t29 = [t1, t2, t15, t28];
    $[40] = t15;
    $[41] = t28;
    $[42] = t29;
  } else {
    t29 = $[42];
  }
  return t29;
}
export function useSectionMap(sections) {
  const $ = _c(2);
  let t0;
  if ($[0] !== sections) {
    t0 = new Map(sections.map(_temp));
    $[0] = sections;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(section) {
  return [section.key, section];
}
export interface SidebarPageEntry {
  name: string;
  href: string;
  section: string;
  subsection?: string;
  icon?: ComponentType<{
    className?: string;
  }>;
}
export function mapSidebarSectionsToPages(sections: SidebarSection[]): SidebarPageEntry[] {
  return sections.flatMap(section => {
    const sectionIcon = section.icon;
    const sectionItems: SidebarPageEntry[] = section.items.map(item => ({
      name: item.name,
      href: item.href,
      section: section.name,
      icon: sectionIcon
    }));
    const subsectionItems = section.subsections?.flatMap(subsection => subsection.items.map(item => ({
      name: item.name,
      href: item.href,
      section: section.name,
      subsection: subsection.name,
      icon: sectionIcon
    }))) ?? [];
    return [...sectionItems, ...subsectionItems];
  });
}